/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonFoodDataLog,
    JsonFoodDataLogFromJSON,
    JsonFoodDataLogFromJSONTyped,
    JsonFoodDataLogToJSON,
} from './JsonFoodDataLog';

/**
 * 
 * @export
 * @interface JsonFoodData
 */
export interface JsonFoodData {
    /**
     * 
     * @type {Array<JsonFoodDataLog>}
     * @memberof JsonFoodData
     */
    log?: Array<JsonFoodDataLog>;
}

export function JsonFoodDataFromJSON(json: any): JsonFoodData {
    return JsonFoodDataFromJSONTyped(json, false);
}

export function JsonFoodDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonFoodData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'log': !exists(json, 'log') ? undefined : ((json['log'] as Array<any>).map(JsonFoodDataLogFromJSON)),
    };
}

export function JsonFoodDataToJSON(value?: JsonFoodData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'log': value.log === undefined ? undefined : ((value.log as Array<any>).map(JsonFoodDataLogToJSON)),
    };
}

